const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/Footer.tsx';
import { VersionInfo } from 'App/components/VersionInfo';
import * as React from 'react';
import LanguageSelector from 'App/components/Footer/LanguageSelector';
import CommonFooter from 'App/components/Footer/CommonFooter';
import { Link, Links } from 'App/components/Footer/Links';
import commonTextMap from 'App/defs/translations';

export const Footer = (props: {}) => {
    return (
        <CommonFooter>
            <Links>
                <Link href="https://www.spitaluster.ch/Ueber-uns/Impressum.963.html" text={commonTextMap.impressum} />
            </Links>
            <VersionInfo />
            <LanguageSelector />
        </CommonFooter>
    );
};

export default Footer;
